<template>
    <div class="IperMatrizPeligrosOpcionesVerificacionCYD">
        <div class="modal fade" :id="'verificacionCYD' + id" tabindex="-1" :aria-labelledby="'verificacionCYDLabel' + id"
            aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content bg-light">
                    <div class="modal-header">
                        <h5 class="modal-title dato" :id="'verificacionCYDLabel' + id">
                            VERIFICACIÓN C&D
                        </h5>
                        <button class="close" data-dismiss="modal" type="button" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <nav>
                            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                                <button class="nav-link active" :id="'nav-consulta-tab' + id" data-toggle="tab"
                                    :data-target="'#nav-consulta' + id" type="button" role="tab"
                                    :aria-controls="'nav-consulta' + id" aria-selected="true">
                                    Consulta
                                </button>
                                <button class="nav-link" :id="'nav-descarga-tab' + id" data-toggle="tab"
                                    :data-target="'#nav-descarga' + id" type="button" role="tab"
                                    :aria-controls="'nav-descarga' + id" aria-selected="false">
                                    Descarga
                                </button>
                            </div>
                        </nav>
                        <div class="tab-content" :id="'nav-tabContent' + id">
                            <!-- HISTORIAL DE CONSULTA-->
                            <div class="tab-pane fade show active" :id="'nav-consulta' + id" role="tabpanel"
                                :aria-labelledby="'nav-consulta-tab' + id">
                                <div v-if="historialConsulta.length > 0" class="scroll-table">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="thead-table-orange">Nombre</th>
                                                <th scope="col" class="thead-table-orange">Correo</th>
                                                <th scope="col" class="thead-table-orange">Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="usuario of historialConsulta" :key="usuario.id">
                                            <tr class="text-center">
                                                <td>{{ usuario.nombre }}</td>
                                                <td>{{ usuario.correo }}</td>
                                                <td>{{ usuario.registro }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-warning text-center" role="alert">
                                    No hay registros de Historial de Consulta para este
                                    <b>Centro de Trabajo</b>.
                                </div>
                            </div>

                            <!-- HISTORIAL DE DESCARGA -->
                            <div class="tab-pane fade" :id="'nav-descarga' + id" role="tabpanel"
                                :aria-labelledby="'nav-descarga-tab' + id">
                                <div v-if="historialDescarga.length > 0" class="scroll-table">
                                    <table class="table">
                                        <thead>
                                            <tr>
                                                <th scope="col" class="thead-table-orange">Nombre</th>
                                                <th scope="col" class="thead-table-orange">Correo</th>
                                                <th scope="col" class="thead-table-orange">Fecha</th>
                                            </tr>
                                        </thead>
                                        <tbody v-for="usuario of historialDescarga" :key="usuario.id">
                                            <tr class="text-center">
                                                <td>{{ usuario.nombre }}</td>
                                                <td>{{ usuario.correo }}</td>
                                                <td>{{ usuario.registro }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <div v-else class="alert alert-warning text-center" role="alert">
                                    No hay registros de Historial de Descarga para este
                                    <b>Centro de Trabajo</b>.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { db } from '@/firebase';
import moment from 'moment';
export default {
    name: "IperMatrizPeligrosOpcionesVerificacionCYD",

    props: {
        id: String,
    },

    data() {
        return {
            historialConsulta: [],
            historialDescarga: [],
        }
    },

    async created() {
        this.$isLoading(true);
        await this.obtenerHistorialConsulta()
        await this.obtenerHistorialDescarga()
        this.$isLoading(false);
    },

    methods: {
        async obtenerHistorialConsulta() {
            this.historialConsulta = [];
            db.collection("historial_consulta").where("idCentroTrabajo", "==", this.id).orderBy("registro.creacion", "desc").onSnapshot((snapshot) => {
                snapshot.docChanges().forEach((change) => {
                    let registro = change.doc.data().registro.creacion;
                    try {
                        registro = registro.toDate();
                    } catch (error) { }
                    registro = moment(registro).format("DD/MM/YYYY");
                    let nombre = null;
                    (async () => {
                        let correoUsuario = change.doc.data().correoUsuario;
                        let obtenerUsuario = null;
                        if (correoUsuario && correoUsuario != "") {
                            obtenerUsuario = await this.obtenerUsuario(correoUsuario);
                        }
                        if (obtenerUsuario) {
                            nombre = obtenerUsuario.nombre;
                        }
                        if (change.type === "added") {
                            this.historialConsulta.unshift({
                                id: `${change.doc.id}`,
                                nombre: nombre,
                                correo: `${change.doc.data().correoUsuario}`,
                                registro: registro,
                            });
                        }
                        if (change.type === "modified") {
                            this.historialConsulta.forEach((usuario) => {
                                if (usuario.id == change.doc.id) {
                                    usuario.nombre = nombre;
                                    usuario.correo = `${change.doc.data().correoUsuario}`;
                                    usuario.registro = registro;
                                }
                            });
                        }
                    })();
                    if (change.type === "removed") {
                        this.historialConsulta.forEach((usuario, index) => {
                            if (usuario.id == change.doc.id) {
                                this.historialConsulta.splice(index, 1);
                            }
                        });
                    }
                    let set = new Set(this.historialConsulta.map(JSON.stringify));
                    this.historialConsulta = Array.from(set).map(JSON.parse);
                });
            }, (error) => {
                console.log(
                    "Error al obtener las actualizaciones en tiempo real para usuarios.",
                    error
                );
            });
        },

        async obtenerHistorialDescarga() {
            this.historialDescarga = [];
            db.collection("historial_descarga").where("idCentroTrabajo", "==", this.id).orderBy("registro.creacion", "desc").onSnapshot((snapshot) => {
                snapshot.docChanges().forEach((change) => {
                    let registro = change.doc.data().registro.creacion;
                    try {
                        registro = registro.toDate();
                    } catch (error) { }
                    registro = moment(registro).format("DD/MM/YYYY");
                    let nombre = null;
                    (async () => {
                        let correoUsuario = change.doc.data().correoUsuario;
                        let obtenerUsuario = null;
                        if (correoUsuario && correoUsuario != "") {
                            obtenerUsuario = await this.obtenerUsuario(correoUsuario);
                        }
                        if (obtenerUsuario) {
                            nombre = obtenerUsuario.nombre;
                        }
                        if (change.type === "added") {
                            this.historialDescarga.unshift({
                                id: `${change.doc.id}`,
                                nombre: nombre,
                                correo: `${change.doc.data().correoUsuario}`,
                                registro: registro,
                            });
                        }
                        if (change.type === "modified") {
                            this.historialDescarga.forEach((usuario) => {
                                if (usuario.id == change.doc.id) {
                                    usuario.nombre = nombre;
                                    usuario.correo = `${change.doc.data().correoUsuario}`;
                                    usuario.registro = registro;
                                }
                            });
                        }
                    })();
                    if (change.type === "removed") {
                        this.historialDescarga.forEach((usuario, index) => {
                            if (usuario.id == change.doc.id) {
                                this.historialDescarga.splice(index, 1);
                            }
                        });
                    }
                    let set = new Set(
                        this.historialDescarga.map(JSON.stringify)
                    );
                    this.historialDescarga = Array.from(set).map(JSON.parse);
                });
            }, (error) => {
                console.log(
                    "Error al obtener las actualizaciones en tiempo real para usuarios.",
                    error
                );
            });
        },

        async obtenerUsuario(correoUsuario) {
            let usuario = null;
            await db.collection("usuarios").where("u_correo", "==", correoUsuario).get().then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                    usuario = {
                        nombre: `${doc.data().u_nombre_usuario} ${doc.data().u_apellido}`,
                    };
                });
            });
            return usuario;
        },
    }
}
</script>

<style scoped>
.thead-table-orange {
    background-color: #ee8813 !important;
    color: #ffffff !important;
    font-size: 14px;
    width: 220px !important;
    border-radius: 18px !important;
    text-align: center !important;
    background-image: linear-gradient(#e8640c, #f39200, #ff9900) !important;
}

.scroll-table {
    overflow-y: auto;
    overflow-x: auto;
    max-height: 500px;
    width: 100%;
    padding-right: 0.5em;
}
</style>